<script lang="ts" content="module">
	import { getClassicWebUrl } from "$lib/components/currentUser";

	const CLASSIC_WEB_URL = getClassicWebUrl();
</script>

<div class="bg-[#fffcd3] py-4">
	<a class="flex flex-wrap items-center justify-between container-1200" href="{CLASSIC_WEB_URL}/app/users/verify_email">
		<div class="flex flex-wrap items-center text-red-600">
			<div class="mr-1 text-orange-600 text-23 material-icons">info</div>
			<span class="items-center mr-1 font-bold align-middle"> Email Verification required:</span>
			to send newsletters, we require email verification.
		</div>
		<div class="hidden font-bold text-nxgray-600 lg:inline-block">Verify your email</div>
	</a>
</div>
